import { SUBSCRIPTION_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_PERMISSION = `${SUBSCRIPTION_SERVICE}/permissions`;

export const permissions = {
  getAll: async () => {
    const options = await apiOptions({
      url: `${API_PERMISSION}`,
      method: "get",
    });
    const response = await apiRequest(options);
    return response;
  },
  get: async (id: string) => {
    const options = await apiOptions({
      url: `${API_PERMISSION}/${id}`,
      method: "get",
    });
    const response = await apiRequest(options);
    return response;
  },
};
